export const INSTALLATION_TIME_RANGES = {
  EXCELLENT: 45,
  GOOD: 60,
  WARNING: 89,
  CRITICAL: 90,
} as const

export const INSTALLATION_TIME_COLORS = {
  EXCELLENT: 'green',
  GOOD: 'yellow',
  WARNING: 'red',
  CRITICAL: 'red',
} as const

export const INSTALLATION_TIME_LABELS = {
  EXCELLENT: '0_45',
  GOOD: '45_60',
  WARNING: '60_89',
  CRITICAL: 'over_90',
} as const
